import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from '@reduxjs/toolkit';

import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
import appSlice from './slices/appSlice';
import commentBoxReducer from './slices/commentBoxSlice';

const rootReducer = combineReducers({
  auth: authSlice,
  ui: uiSlice,
  app: appSlice,
  commentBox: commentBoxReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
